import { memo } from 'react';
import { FreeformContainer } from './freeform-container';
import { CustomPlug } from '../user-chat-message';
import { BotChatMessageAvatar } from '../bot-chat-message/bot-chat-message-avatar';
import { useTheme } from 'styled-components';
import { BotChatMessageContainer } from '../bot-chat-message/bot-chat-message-container';
import FreeFormIcon from '../../../../components/icons/free-form';
import { FreeformTitle } from './freeform-title';

export const Freeform = memo(() => {
  const theme = useTheme();

  return (
    <BotChatMessageContainer className="voa_chat_bot_suggestion_chips_item_container">
      <CustomPlug>
        <BotChatMessageAvatar
          src={theme?.themeConfig?.chatMessages?.botMessage?.avatar?.src}
        />
      </CustomPlug>

      <FreeformContainer className="text-instruction">
        <FreeFormIcon />
        <FreeformTitle>
          {theme?.themeConfig?.chatMessages?.freeform?.title?.text}
        </FreeformTitle>
      </FreeformContainer>
    </BotChatMessageContainer>
  );
});